<i18n>
    {
        "cn": {
            work: "名称",
            client: "客户",
            artist: "艺术家",
        },
        "en": {
            work: "Work",
            client: "Client",
            artist: "Artist",
        },
    }
</i18n>
<script>
export default {
    props: ['show', 'data', 'index'],
    name: "imagesPanzoom",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                // loop: true,
                lazy: {
                    // loadPrevNext: true,
                },
            },
            realIndex: null,
            isLoading: false,
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {

    },
    mounted() {
        
    },
    destroyed() {},
    watch: {
        show: {
            handler: function (val) {
                if (val) {
                    this.realIndex = this.index;
                    this.isLoading = true;
                    this.swiper.slideTo(this.index, 0);
                    this.swiper.lazy.loadInSlide(this.index);
                }
            },
            // immediate: true
        }
    },
    methods: {
        toPrev() {
            this.swiper.slidePrev();
        },
        toNext() {
            this.swiper.slideNext();
        },
        swiperReady() { 

        },
        changeEnd() { 
            this.realIndex = this.swiper.activeIndex;
        },
    },
};
</script>

<template>
    <div class="images_zoom position_100" :class="{show: show}">
        <!-- 大图 -->
        <swiper class="wrapper" ref="mySwiper" :options="swiperOptions" @ready="swiperReady" @slideChangeTransitionEnd="changeEnd">
            <swiper-slide class="flex justify_center align_center" v-for="(item, index) in data" :key="index">
                <!-- 背景关闭 -->
                <div class="position_100" @click="$emit('close')"></div>
                <!-- loading -->
                <div class="swiper-lazy-preloader"></div>
                <!--  -->
                <img class="swiper-lazy" v-if="item.type == 1" :data-src="item.image" alt=""/>
                <video class="swiper-lazy" v-else-if="item.type == 2" :data-src="item.image" controls x5-playsinline playsinline webkit-playsinline x5-video-player-type></video>
                <img class="swiper-lazy" v-else :data-src="item.image" alt=""/>
            </swiper-slide>
        </swiper>
        <!-- 底部 -->
        <div class="bottom flex justify_between" v-if="realIndex != null">
            <!-- 图片视频信息 -->
            <div class="info flex flex_column justify_center">
                <p class="name">{{ data[realIndex].name }}</p>
                <p v-if="data[realIndex].artist_name">{{ $t('artist') }}：{{ data[realIndex].artist_name }}</p>
                <p v-if="data[realIndex].customer">{{ $t('client') }}：{{ data[realIndex].customer }}</p>
            </div>
            <!-- 右侧控件 -->
            <div class="flex flex_column justify_center align_end">
                <div class="btn_close" @click="$emit('close')"></div>
                <div class="button_group flex align_center">
                    <div class="btn_prev" @click="toPrev"></div>
                    <div class="page_num">{{ realIndex + 1 }} / {{ data.length }}</div>
                    <div class="btn_next" @click="toNext"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.images_zoom{
    background: rgba($color: #000000, $alpha: .5);
    position: fixed;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    &.show{
        opacity: 1;
        visibility: visible;
    }
}
.wrapper{
    height: calc(100% - 1.1rem);
    // flex: 1;
    position: relative;
    // --swiper-theme-color: #ff6600;
    --swiper-preloader-color: #fff;
    .swiper-slide{
        padding: .5rem;
    }
    video,
    img{
        max-width: 100%;
        max-height: 100%;
        // cursor: zoom-in;
        position: relative;
        z-index: 1;
    }
    @media only screen and (max-width: 750px) {
        height: calc(100% - 2rem);
    }
}
.bottom{
    // flex-shrink: 0;
    height: 1.1rem;
    background: #fff;
    padding: 0 2.7rem;
    @media only screen and (max-width: 750px) {
        height: 2rem;
        padding: 0 .5rem;
    }
    .info{
        font-size: .16rem;
        .name{
            font-size: .22rem;
        }
        @media only screen and (max-width: 750px) {
            font-size: .22rem;
            .name{
                font-size: .36rem;
                margin-bottom: .1rem;
            }
        }
    }
    .btn_close{
        width: .26rem;
        height: .26rem;
        background: url('~@/assets/images/icon_close.png') no-repeat center/.16rem;
        margin-bottom: .2rem;
        cursor: pointer;
        @media only screen and (max-width: 750px) {
            background-size: .24rem;
        }
    }
    .button_group{
        font-size: .22rem;
        @media only screen and (max-width: 750px) {
            font-size: .26rem;
        }
        .btn_prev,
        .btn_next{
            height: 100%;
            padding: 0 .1rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            @media only screen and (max-width: 750px) {
                display: none;
            }
            &::after{
                display: block;
                content: "";
                width: .1rem;
                height: .1rem;
                border-top: 1px solid #000;
                border-right: 1px solid #000;
                transform: rotate(45deg);
            }
        }
        .btn_prev{
            &::after{
                transform: rotate(-135deg);
            }
        }
    }
}
</style>